<template>
  <div id="welcome">
    <!--    <h2>{{ message }}</h2>-->
    <div><img src="../../assets/welcone.png" /> </div>
  </div>
</template>

<script>
export default {
  name: "welcome",
  data() {
    return {
      message: "welcome"
    };
  },
  mounted() { },
  created() { },
  methods: {},

};
</script>

<style scoped lang="scss">
#welcome {
  font-size: 20px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: white;

  div {
    img {
      width: 100%;
      min-width: 700px;
      margin: auto;
    }
  }
}
</style>
